//@ts-check

/** @type import("../../types/themes").LegacyAliasGenerator */
const addLegacyAliases = (baseAliases) => {
  const alert = baseAliases.error;
  const danger = baseAliases.error;
  const primary = baseAliases.highlight;

  return {
    ...baseAliases,
    danger,
    alert,
    primary,
  };
};

export default addLegacyAliases;
